<div *ngIf="categories">
  <div *ngFor="let category of categories">
    <button mat-menu-item>
      <b>{{category.vName}}</b>
    </button>
    <div *ngIf="category.subCategories" class="sub-category">
      <div *ngFor="let subCategory of category.subCategories">
        <button mat-menu-item>
          <a mat-menu-item [routerLink]="['/products', subCategory.id, subCategory.vName]">{{subCategory.vName}}</a>
        </button>
      </div>
    </div>
  </div>
</div>
